module.exports = __webpack_public_path__ + "static/img/199_TO8_2102.ff42d27.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/199_TO8_2102.jpg
// module id = y+8Y
// module chunks = 0